import { isSet } from 'ember-route-state/utils/nullish.js';

export function arrayMatches(authority, candidate) {
  candidate = candidate?.splice() || [];
  return authority.every(value => {
    const index = candidate.indexOf(value);
    if (index >= 0) {
      candidate.splice(index, 1);
      return true;
    }
  }) && !candidate.length;
}

export function objectMatches(authority, candidate) {
  const keys = new Set(
    Object.entries(candidate)
      .filter(([ key, value ]) => isSet(value))
      .map(([ key ]) => key)
  );
  return Object.entries(authority).every(([ key, value ]) => {
    if (valueMatches(value, candidate[key])) {
      keys.delete(key);
      return true;
    }
  }) && !keys.size;
}

export function valueMatches(authority, candidate) {
  const isAuthoritySet = isSet(authority);
  const isCandidateSet = isSet(candidate);
  // If one is set and the other isn't, then they differ
  return isAuthoritySet !== isCandidateSet ? false
    : (
      // If authority is not set, then consider it a match
      !isAuthoritySet
      || (
        // Compare arrays...
        Array.isArray(authority) ? arrayMatches(authority, candidate)
        // Compare objects...
        : typeof authority === 'object' ? objectMatches(authority, candidate)
        // Compare scalars...
        // jshint eqeqeq: false
        : authority == candidate
      )
    );
}

export const transformQueryParams = (route, queryParams, methodName) => {
  if (!route?.[methodName]) {
    return queryParams;
  }
  const result = {};
  Object.keys(queryParams || {}).forEach(key => {
    if (route.queryParams[key]) {
      result[key] = route[methodName](queryParams[key], key);
    }
  });
  return result;
};

export const serializeQueryParams = (route, queryParams) => {
  return transformQueryParams(route, queryParams, 'serializeQueryParam');
};

export const deserializeQueryParams = (route, queryParams) => {
  return transformQueryParams(route, queryParams, 'deserializeQueryParam');
};
